export class KeyValuePair {
  key: string;
  value: string;
}

export class OverviewCardConfig {
  label: string;
  endpoint?: string;
  data?: any;
  statuses?: KeyValuePair[];
  message?: string;
  icons?: any;

  // can use these two if you have a response for the overview card like the one seen below
  // { status: 'in_progress', count: 145 }
  hasStatusCount?: boolean;
  statusCountProp?: string;
}

export class OverviewGroup {
  status_key: string;
  status_value: string;
  items: any[];

  // Used if you are passing one obj for each status along with a property containing
  // the num of statuses for the status.
  count?: number;
}

export const defaultOverviewCardStatuses: KeyValuePair[] = [
  {
    key: 'in_progress',
    value: 'In Progress',
  },
  {
    key: 'quoted',
    value: 'Quoted',
  },
  {
    key: 'expired',
    value: 'Expired',
  },
  {
    key: 'pended',
    value: 'Pended',
  },
];
